<template>
<div class="overflow">
     <HeadDetailsGama v-on:openIS="openimageselector"
     v-on:openF="openFiles"
     :btnEspelhoVenda="true"
     :titleHead="'Detalhe do Empreendimento'">
     </HeadDetailsGama>
      <div id="body-details">
           <div id="head-details" class="pt-2">
              <div class="d-flex">
               <input type="file" v-on:change="imporTable" id="impor-ex-price" itemid="impor-ex">
             </div>
           </div>
          <div v-for="(data, i) in  dataTable" v-bind:key="data.id" class="mb-2 mt-4  w-100 ">
            <Tablepriceacording  @openLinkVirtual="openLinkVirtual" v-on:openUS="openunitytypeselector"  :id="id" :data="data" :dataCol="data.lstREEmpreendimentoUnidadePreco" :i="i"></Tablepriceacording>
          </div>
      </div>
        <imageselector :data="data" ref="imageselectormodal"></imageselector>
        <UnityTypeSelector :data="data" ref="openunitytype"></UnityTypeSelector>

        <b-modal hide-footer size="lg" centered ref="linkvirtual" id="UnityTypeImages" title="ADICIONAR LINK VIRTUAL"
          class="centralizatexto">
          <template #modal-title>
                <div class="header-title">ADICIONAR LINK VIRTUAL</div>
            </template>
          <div class="d-flex justify-content-center">
           <div class="w-75">
            <label class="label-add-link">Link Tour:</label>
             <input placeholder="Insira URL" class="form-control" v-model="virtualform.linkTour">
              <label class="label-add-link">Descrição:</label>
            <textarea placeholder="" class="form-control" v-model="virtualform.descricaoTour"></textarea>
           </div>
          </div>
          <div class="d-flex justify-content-center mt-4">
            <button class="button-can mr-2" @click="hidemodaladdlink">Cancelar</button>
            <button class="button-apr ml-2" @click="SaveLinkTour">Enviar</button>
          </div>

            </b-modal>

</div>
</template>

<script>
import TablePrice from './tableprice'
export default TablePrice

</script>

<style scoped>
.overflow {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height:1500px;
}
.head-mes{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
}
.componente{
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}
.label-add-link{
  line-height: 0px;
  margin-top: 25px;
  font-size: 14px;
  font-weight: bold;
}
.buttonImage {
  top: 0;
  margin-top: 500px;
  position: absolute;
  background-color:transparent;
  color: black;
  border: none;
  width: 30px;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
  border-radius: 6px;
}
.button-can{
  height: 40px;
  width: 30%;
  border-radius: 10px;
  border: none;
  background: red;
  font-size: 14px;
  color: white;
}

.button-can:hover{
  height: 40px;
  width: 30%;
  background: #be2b2b;
  color: white;
  border: none;
  font-size: 14px;
  border-radius: 10px;
}
.button-apr{
  background: #008148;
  height: 40px;
  font-size: 14px;
  color: white;
  width: 30%;
  border-radius: 10px;
  border: none;

}

.button-apr:hover{
  background: #008147d7;
  height: 40px;
  font-size: 14px;
  color: white;
  width: 30%;
  border-radius: 10px;
  border: none;

}

.buttonImage:hover{
  background-color: rgba(141, 141, 141, 0.333);
}
.icon-search{
  position: absolute;
  top:  10px;
  left: 10px;
}

#body-details{
    height: 60vh;
}
#head-details{
  display: flex;
  justify-content: space-between;
}
.input-paddi{
  padding-left: 28px;

}
.input-rela{
  position: relative;
}
.btn-new-gru{
  height: 30px;
  width: 181px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.btn-new-gru:hover{
  color: white;
  background: #008147d7;
}
.title-colapse-table{
    color: #008148;
    font-size: 20px;
    font-weight: bold;
}
#impor-ex-price{
  display: none;
}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/tableprice/tableprice.vue